module.exports = __webpack_public_path__ + "img/certificate.364c207b.png";